export default __webpack_public_path__ + "static/media/img1.01ea1044.png";